<template lang="pug">
.form-group
  label.form-group__label.semibold.label {{title}}
  .search-block
    input.search-block__input.input(
      type="search"
      placeholder="Наименование"
      v-model="query"
      v-debounce:300="searchList"
    )
    ul.search-block__list.reset-list(
      v-if="list.length"
    )
      li.search-block__item.type.custom-radio(
        v-for="item in list" :key="'list' + item.id"
      )
        label.custom-radio__label.label
          input.custom-radio__input.visually-hidden(
            type="radio"
            :name='endpoint + index'
            v-model="item.checked"
            @change="(event) => checkItem(event, item)"
          )
          span.custom-radio__block
          span.custom-radio__text {{item.name}}
</template>

<script>
import { tko, garbage } from '@/api/api-endpoints'

const PER_PAGE = 10

export default {
  name: 'SearchObject',
  props: {
    title: {
      type: String,
      required: true,
    },
    endpoint: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      list: [],
      query: '',
    }
  },
  methods: {
    checkItem(event, item) {
      this.query = item.name
      this.$emit('selectItem', [item.latitude, item.longitude])
    },
    getEndpoint(q) {
      const query = {
        q,
        'per-page': PER_PAGE,
        fields: 'id, name, longitude, latitude',
      }
      switch (this.endpoint) {
        case 'garbage':
          return garbage.source({ query })
        case 'tko':
          return tko.objects({ query })
      }
    },
    async searchList() {
      const query = this.query
      if (!query) {
        this.list = []
      } else {
        let data = await (
          await this.$store.dispatch('updateUrlEndpoint', {
            endpoint: this.getEndpoint(query),
            fromCache: false,
          })
        ).data
        data = data.data || data.container
        this.list = data
      }
    },
  },
}
</script>
